/**
 * @generated SignedSource<<2e01c59fe62a032a30014abb664db5f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingsPanelMenu_viewer$data = {
  readonly uxSimplificationEnabled: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"EventFilters_viewer">;
  readonly " $fragmentType": "MeetingsPanelMenu_viewer";
};
export type MeetingsPanelMenu_viewer$key = {
  readonly " $data"?: MeetingsPanelMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingsPanelMenu_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingsPanelMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxSimplificationEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ffd65bf1b060233c9aa16e14cd50bd98";

export default node;
